import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '@/store';
import { PaginationState, SortingState } from '@tanstack/react-table';
import { ActiveUserData } from '@/api';

interface ActiveUsersListState {
  activeUsersList: ActiveUserData[];
  activeUsersListPagination: PaginationState;
  activeUsersListSorting: SortingState;
}

const initialState: ActiveUsersListState = {
  activeUsersList: [],
  activeUsersListPagination: {
    pageIndex: 0,
    pageSize: 50,
  },
  activeUsersListSorting: [],
};

const activeUsersSlice = createSlice({
  name: 'activeUsers',
  initialState: initialState,
  reducers: {
    setActiveUsersList: (state, action: PayloadAction<ActiveUserData[]>) => {
      state.activeUsersList = action.payload;
    },
    setActiveUsersPagination: (state, action: PayloadAction<PaginationState>) => {
      state.activeUsersListPagination = action.payload;
    },
    setActiveUsersSorting: (state, action: PayloadAction<SortingState>) => {
      state.activeUsersListSorting = action.payload;
    },
  },
});

export const { setActiveUsersList, setActiveUsersPagination, setActiveUsersSorting } = activeUsersSlice.actions;

export const selectActiveUsersList = (state: RootState) => {
  return state.activeUsers.activeUsersList;
};
export const selectActiveUsersPagination = (state: RootState) => {
  return state.activeUsers.activeUsersListPagination;
};
export const selectActiveUsersSorting = (state: RootState) => {
  return state.activeUsers.activeUsersListSorting;
};

export const activeUsersReducer = activeUsersSlice.reducer;
